import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { normalizeSocialLink as m } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as o } from "../../utils/get-social-link-icon.mjs";
import s from "../../../components/store-image.mjs";
import { useStore as c } from "../../../store/index.mjs";
import { StoreImageEnum as p } from "../../../enums/store-image-enum.mjs";
const u = ({ profile: r, socialLinks: l }) => {
  var n;
  const { locale: a } = c();
  return /* @__PURE__ */ i(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      className: "flex w-full flex-col items-center justify-center gap-5 px-5 py-10 sm:max-w-xl sm:px-0",
      children: [
        /* @__PURE__ */ e(
          s,
          {
            width: 200,
            height: 200,
            alt: r.sellerName,
            imageType: p.profile,
            src: (n = r.sellerPhoto) == null ? void 0 : n.path,
            className: "rounded-full object-cover"
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            className: "z-1 flex flex-col items-center justify-center gap-4 text-center font-normal",
            children: [
              /* @__PURE__ */ e(
                "h1",
                {
                  id: "region-heading",
                  lang: a,
                  className: "text-THEME-primary break-all text-[48px] leading-[62px]",
                  children: r.sellerName
                }
              ),
              /* @__PURE__ */ e("span", { lang: a, className: "hyphens-auto text-[18px] leading-[27px] text-[#242424]", children: r.bio }),
              !!l.length && /* @__PURE__ */ e("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: l.map((t) => /* @__PURE__ */ e(
                "a",
                {
                  href: m(t),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "p-1",
                  "aria-label": t.type,
                  children: o(t.type, "fill-[#242424] ")
                },
                t.type
              )) })
            ]
          }
        )
      ]
    }
  );
};
export {
  u as ProfileCreamy
};
